import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Loader2 } from 'lucide-react';
import { savePostLoginRedirect } from '../utils/postLoginRedirect';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className='min-h-screen flex items-center justify-center bg-gray-50'>
        <div className='text-center'>
          <Loader2 className='h-8 w-8 animate-spin text-primary-600 mx-auto mb-4' />
          <p className='text-gray-600'>Carregando...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    // Link direto para uma página interna: lembrar o destino para depois do SSO
    savePostLoginRedirect(`${location.pathname}${location.search}${location.hash}`);
    return <Navigate to='/login' replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
